import { HTTP, authHeader, HTTP_FILE } from './http-service';

class SchemeBusinessService {
  get(schemeId, schemeBusinessId) {
    return HTTP.get(`/SchemeBusiness/${schemeId}/${schemeBusinessId}/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateBusinessRegistration(schemeId, schemeBusinessId, businessRegistration) {
    return HTTP.put(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/business-registration`,
      {
        businessRegistrationNumber: businessRegistration.businessRegistrationNumber,
        businessType: businessRegistration.businessType,
      },
      {
        headers: authHeader(),
      },
    ).then((response) => response.data);
  }

  resubmit(schemeId, schemeBusinessId) {
    return HTTP.put(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/resubmit`,
      {},
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  rematch(schemeId, schemeBusinessId, tmln) {
    return HTTP.put(
      `/PendingLicenceAction/rematch`,
      {
        schemeId,
        schemeBusinessId,
        tmln,
      },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  publishtrades(schemeId, schemeBusinessId) {
    return HTTP.post(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/publishtrades`,
      {},
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  createLodgementPortalLogin(schemeId, schemeBusinessId, email) {
    return HTTP.post(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/lodgementPortalLogin`,
      { email },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  listLegacyLodgementBranches(schemeId, schemeBusinessId) {
    return HTTP.get(`/SchemeBusiness/${schemeId}/${schemeBusinessId}/legacylodgement/branches`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  listWatchlistHistory(schemeId, schemeBusinessId) {
    return HTTP.get(`/SchemeBusiness/${schemeId}/${schemeBusinessId}/watchlist`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateWatchlistHistory(schemeId, schemeBusinessId, watchlistHistory) {
    return HTTP.put(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/watchlist`,
      {
        ...watchlistHistory,
      },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  updateWatchlistStatus(schemeId, schemeBusinessId, watchlistStatus) {
    return HTTP.post(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/watchlist`,
      {
        watchlistStatus,
      },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  verificationSearch(payload) {
    return HTTP.post(`/VerificationSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  verificationSearchAdvanced(payload) {
    return HTTP.post(`/VerificationSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateCeaseToTrade(schemeId, schemeBusinessId, ceaseToTrade) {
    return HTTP.put(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/ceaseToTrade`,
      {
        ...ceaseToTrade,
      },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  getSignedUrl(schemeBusinessId, filename) {
    return HTTP_FILE.get(
      `/SchemeBusinessFile/GetPresignedPost/${schemeBusinessId}?filename=${encodeURIComponent(filename)}`,
    ).then((response) => {
      return response.data;
    });
  }

  getDownloadUrl(link) {
    return HTTP_FILE.get(`/SchemeBusinessFile/download/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }

  deleteFile(link) {
    return HTTP_FILE.delete(`/SchemeBusinessFile/${encodeURIComponent(link)}`).then((response) => {
      return response.data;
    });
  }

  getSchemeBusinesses(disputeId) {
    return HTTP.get(`/SchemeBusiness/${disputeId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getCompaniesHouseInsolvency(registeredCompanyNumber) {
    return HTTP.get(`/CompaniesHouse/companies-house/${registeredCompanyNumber}/insolvency`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateRegisteredCompanyNumber({ schemeId, schemeBusinessId, registeredCompanyNumber }) {
    return HTTP.put(
      `/SchemeBusiness/${schemeId}/${schemeBusinessId}/registered-company-number`,
      { schemeId, schemeBusinessId, registeredCompanyNumber },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }
}

export default new SchemeBusinessService();
